<template>
  <figure class="app-hero-image-single">
    <img class="image" :alt="media.alt" :src="media.url" fetchpriority="high" />
  </figure>
</template>

<script>
export default {
  name: 'AppHeroImageSingle',
  props: {
    media: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-hero-image-single {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  max-height: 600px;

  .image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    background-color: vars.$c-gray-d8;
  }

  @media (min-width: vars.$desktop-xl-1400-break-point) {
    aspect-ratio: 1440 / 600; /* wider, more cinematic */
  }

  // lg — Laptop / small desktop  (1024 px – 1279 px)
  @media (max-width: vars.$media-1279) {
    aspect-ratio: 16 / 7.5;
  }

  // md — Tablet  (768 px – 1023 px)
  @media (max-width: vars.$desktop-lg-1024-break-point - 1) {
    aspect-ratio: 4 / 3;

    /* Shift focus toward the subject if they're slightly off-centre */
    .image {
      object-position: 60% center;
    }
  }

  // sm — Large mobile  (480 px – 767 px)
  @media (max-width: vars.$tablet-break-point - 1) {
    aspect-ratio: 3 / 4; /* portrait — shows more of the subject */

    .image {
      object-position: 55% top; /* keep face / upper body in frame */
    }
  }

  // xs — Small mobile  (< 480 px). Square-ish crop; minimal button footprint.
  @media (max-width: vars.$mobile-break-point-480 - 1) {
    aspect-ratio: 1 / 1;

    .image {
      object-position: 50% 20%; /* bias toward top so face stays visible */
    }
  }
}
</style>
